<template lang="pug">
  .row.justify-content-center
    .col-sm-6
      .thank-you-message
        h2 {{ $t('thanks') }}
        template(v-for="note in subnote[locale]")
          p.pf-subnote {{ note }}
        button(@click="goHome").pf-button {{ $t('goBack') }}
</template>

<script>
export default {
  name: 'StepOne',
  data() {
    return {
      subnote: window.layoutoneNote,
    };
  },
  methods: {
    goHome() {
      this.goToSpecificStep(1);
      this.$router.push({ name: 'LayoutOne' });
    },
  },
};
</script>
